/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { RootState, VariableListingIndexedItem, VariableState } from '../types';

export const getVariables = (state: RootState): VariableListingIndexedItem =>
  state.selectedTemplate.variables;
export const getVariableById = (state: RootState, id: number): VariableState =>
  state.selectedTemplate.variables[id];
